import { UnitOfMeasurementEnum } from 'src/app/crop-aid/crop-aid.model';

export interface GetSewageSludgeCompostTransportsResponse {
  receivedVzcTransports: GetSewageSludgeCompostTransport[];
  dispatchedVzcTransports: GetSewageSludgeCompostTransport[];
}

export interface GetSewageSludgeCompostTransport {
  status: VZCTransportStatus;
  loadDate: string;
  unloadDate: string;
  supplier: string;
  transporter: string;
  receiver: string;
  manureCode: string;
  cropAid: SewageSludgeCompostTransportResponseCropAid;
  tonnage: number;
  phosphateInKg: number;
  nitrogenInKg: number;
  phosphateContent: number;
  nitrogenContent: number;
}

export interface SewageSludgeCompostTransports {
  receivedVzcTransports: SewageSludgeCompostTransport[];
  dispatchedVzcTransports: SewageSludgeCompostTransport[];
}

export interface SewageSludgeCompostTransport {
  id: number;
  status: VZCTransportStatus;
  transportType: VZCTransportType;
  loadDate: string;
  unloadDate: string;
  periodId: number;
  supplier: string;
  transporter: string;
  receiver: string;
  manureCode: string;
  cropAid?: SewageSludgeCompostTransportResponseCropAid;
  cropAidName: string;
  tonnage: number;
  phosphateInKg: number;
  nitrogenInKg: number;
  phosphateContent: number;
  nitrogenContent: number;
  comment: string;
}

export interface SewageSludgeCompostTransportResponseCropAid {
  id: number;
  name: string;
  unitOfMeasurement: UnitOfMeasurementEnum;
}

export enum VZCTransportStatus {
  Accepted = 10,
  InProgress = 45,
  Expired = 90,
  Invalid = 0,
}

export enum VZCTransportType {
  Received = 'Received',
  Dispatched = 'Dispatched',
}
